import Fonts, { FontSize } from "@microdoing/shared/constants/Fonts";

// need to define fonts
export const textVariants = {
  defaults: {
    color: "neutral.900",
    ...Fonts.montserrat.regular,
    ...FontSize.m,
  },
  textButton: {
    ...Fonts.inter.semiBold,
    ...FontSize.xm,
    marginHorizontal: "s",
  },
  textInput: {
    padding: {
      phone: "s",
    },
    margin: {
      phone: "m",
    },
    backgroundColor: "neutral.300",
    borderColor: "neutral.900",
    shadowColor: "neutral.600",
  },
  "l1-regular": {},
  "l1-medium": {},
  "l1-semibold": {},
  "l1-bold": {},
  "l2-medium": {},
  "l2-semibold": {},
  "l2-bold": {},
  "l2-regular": {},
  "l3-regular": {},
  "l3-medium": {},
  "l3-semibold": {},
  "l3-bold": {},
  "l4-regular": {},
  "l4-medium": {},
  "l4-semibold": {},
  "l4-bold": {},
  "l5-regular": {},
  "l5-medium": {},
  "l5-semibold": {},
  "l5-bold": {},
  "l6-medium": {},
  "l6-bold": {},
  "l7-regular": {},
  "l7-semibold": {},
  "l7-bold": {},
  "l8-bold": {},
  "l9-bold": {},
  "l10-bold": {},
};
